import React, { Component } from 'react';
import central from '../api/Central';

class Logo extends Component {

    render() {
        return (
            <img className="img logo" src={
                central.getUrlLogo() + "?"
                + (this.props.width ? "&width=" + this.props.width : "")
                + (this.props.height ? "&height=" + this.props.height : "")
            } alt="Logo" />
        );
    }
}

export default Logo;